<script>
// import axios from "axios";

/**
 * Preloader component
 */
export default {
  data() {
    return {};
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed:{
    // logoSrc() {
    //   return require('@/assets/images/logo724.png');
    // },
  },
  watch: {
    loading(value) {
      if (value) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
  },
  mounted() {
    if (!this.loading) {
      document.body.style.overflow = '';
    }
  },
};
</script>

<template>
  <div>
    <div v-if="loading" class="loader-preloader-component">
      <div class="loader-status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
        <!-- <img :src="logoSrc" alt="Cargando..." class="loading-logo" /> -->
      </div>
    </div>
    <slot />
  </div>
</template>

<style>
.loader-preloader-component {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  overflow: hidden;
}

.loader-status img.loading-logo {
  width: auto;
  height: 100px;
  animation: rotate-logo 1.5s linear infinite;
}

@keyframes rotate-logo {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>